import { ArrowUp } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLang } from "@/lang";

const Footer = () => {
  const { t, scrollTo } = useLang();
  const navigate = useNavigate();
  const location = useLocation();

  const goLink = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollTo(id), 450);
      return;
    }
    scrollTo(id);
  };

  const links = [
    { id: "#services", label: t.nav.services, testid: "footer-link-services" },
    { id: "#methode", label: t.nav.method, testid: "footer-link-method" },
    { id: "#chiffres", label: t.nav.stats, testid: "footer-link-stats" },
    { id: "#contact", label: t.nav.contact, testid: "footer-link-contact" },
  ];

  return (
    <footer data-testid="main-footer" className="bg-bei-navy pb-10 pt-16 sm:pt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 border-b border-white/10 pb-12 md:grid-cols-3">
          <div>
            <span className="inline-block rounded-lg bg-white px-4 py-2.5">
              <img src="/assets/beintec-logo-hd.png" alt="BEINTEC" className="h-9 w-auto" />
            </span>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">{t.footer.tagline}</p>
          </div>
          <div>
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">
              {t.footer.navTitle}
            </p>
            <div className="mt-5 flex flex-col gap-3">
              {links.map((l) => (
                <button
                  key={l.id}
                  data-testid={l.testid}
                  onClick={() => goLink(l.id)}
                  className="w-fit text-sm font-medium text-slate-300 transition-colors hover:text-bei-cyan"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">
              {t.footer.contactTitle}
            </p>
            <div className="mt-5 space-y-2 text-sm text-slate-300">
              <p>{t.contact.address}</p>
              <a href="tel:+33161122539" data-testid="footer-phone" className="block transition-colors hover:text-bei-cyan">
                01 61 12 25 39
              </a>
              <a href="mailto:contact@beintec.com" data-testid="footer-email" className="block transition-colors hover:text-bei-cyan">
                contact@beintec.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 sm:flex-row">
          <p data-testid="footer-rights" className="text-xs text-slate-500">
            {t.footer.rights}
          </p>
          <div className="flex items-center gap-6 text-xs text-slate-500">
            <button data-testid="footer-legal" onClick={() => navigate("/mentions-legales")} className="transition-colors hover:text-bei-cyan">
              {t.footer.legal}
            </button>
            <button data-testid="footer-privacy" onClick={() => navigate("/politique-confidentialite")} className="transition-colors hover:text-bei-cyan">
              {t.footer.privacy}
            </button>
            <button
              data-testid="footer-back-to-top"
              onClick={() => scrollTo(0)}
              className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-300 transition-all duration-300 hover:border-bei-cyan hover:text-bei-cyan"
            >
              {t.footer.top}
              <ArrowUp className="h-3.5 w-3.5" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
